import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductsService } from '../../services/products.service';

@Component({
    selector: 'app-base-costs',
    templateUrl: './base-costs.component.html',
    styleUrls: ['./base-costs.component.scss']
})
export class BaseCostsComponent implements OnInit {
    @Input() supplierId;
    @Output() next = new EventEmitter();

    form: FormGroup;
    enableBaseCost = true;

    baseItems = {
        baseWeight: 0,
        baseCost: 0,
        baseCostSQM: 0,
        amendedBaseWeight: 0,
        amendedBaseCost: 0,
        amendedBaseCostSQM: 0,
    };

    constructor(
        private productService: ProductsService,
        private fb: FormBuilder,
    ) {
        this.form = this.fb.group({
            baseCost: [0, [Validators.required, Validators.min(0)]],
            baseCostSQM: [0, [Validators.required]],
            baseWeight: [2200, [Validators.required, Validators.min(1)]],
            amendedBaseCost: [0, [Validators.required]],
            amendedBaseCostSQM: [0, [Validators.required]],
            amendedBaseWeight: [0, [Validators.required]],
        });

    }

    ngOnInit(): void {
        this.getBaseItems();
    }

    getBaseItems() {
        this.productService.getBaseItems(this.supplierId).subscribe(data => {
            this.baseItems = data.data;
            this.form.patchValue({
                baseCost: data.data.baseCost,
                baseCostSQM: data.data.baseCostSQM,
                baseWeight: data.data.baseWeight,
                amendedBaseCost: data.data.amendedBaseCost,
                amendedBaseWeight: data.data.amendedBaseWeight,
            });
        });
    }

    setBaseItems() {
        this.baseItems.baseCost = this.form.value.baseCost;
        this.baseItems.baseCostSQM = this.form.value.baseCostSQM;
        this.baseItems.baseWeight = this.form.value.baseWeight;
        this.baseItems.amendedBaseCost = this.form.value.amendedBaseCost;
        this.baseItems.amendedBaseCostSQM = this.form.value.amendedBaseCostSQM;
        this.baseItems.amendedBaseWeight = this.form.value.amendedBaseWeight;

        this.productService.setBaseItems(this.baseItems, this.supplierId).subscribe(data => {
            this.next.emit();
        });
    }

    toggleBaseCost() {
        if (!this.enableBaseCost) {
            this.enableBaseCost = true;
        } else {
            this.enableBaseCost = false;
            this.form.patchValue({
                baseCost: 0,
            });
        }
    }
}
